const SaleStatus = Object.freeze({
    'NotAvailable': 1,
    'WithContact': 2,
    'WithPrice': 3,
    'ConsignedToAuction': 4
});

module.exports = { SaleStatus };
